// assets
import colors from 'assets/scss/_themes-vars.module.scss';

export const themeDark = {
    active: {
        heading: colors.grey300,
        paper: colors.darkLevel6,
        defaultBg: colors.darkBackground,
        backGround: colors.darkPaper,
        darkTextPrimary: colors.darkTextSecondary,
        primaryLight: colors.darkLevel1,
        secondaryLight: colors.darkSecondaryLight,
        secondaryDark: colors.darkLevel5,
        darkTextSecondary: colors.darkTextSecondary,
        textDark: colors.paper,
        secondary800: colors.paper,
        warningLight: colors.darkLevel1,
        secondaryMain: colors.secondaryMainDark,
        grey50: colors.darkBackground,
        secondary200: colors.darkSecondary200,
        grey500: colors.darkTextSecondary,
        grey999: colors.grey999,
        grey5002: colors.grey500,
        menuSelected: colors.paper,
        menuSelectedBack: colors.darkLevel1,
        divider: colors.darkBackground,
    },
};

export default themeDark;
